import React from 'react'
import styled from 'styled-components'
import { useLibraryImports } from '../../../../../data/hooks/profile'
import Loader from '../../../loader'
import { LibraryImportStatus } from '../../../../../data/profile/data-types'
import { formatDate } from '../../../../../utilities/date'
import SingleImport from './single-import'

type LibraryImportsProps = {
  // Add your prop types here
}

const LibraryImports: React.FunctionComponent<LibraryImportsProps> = () => {
    const { pending, error, data } = useLibraryImports()

    return (
        <Container>
        { pending && <Loader />}
        { 
            !pending && data && 
            <Wrapper>
                { data.map(im => <SingleImport library_import={im}/>) }
            </Wrapper>
        }
        </Container>
    )
}

const Container = styled.div`
    display: grid;

    justify-items: center;
    align-items: center;

    width: 100%;
`

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 48px;

    justify-items: start;
    align-items: center;

    width: 100%;
`

export default LibraryImports